// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ipv1","delete":"styles_delete__3Rh3X","update":"styles_update__bCszq","add":"styles_add__11Jv4"};